const initialState = null;

function reducer(state = initialState, action) {
    if (action.type === 'LOGOUT_REQUEST' || action.type === 'AUTHENTICATE_REQUEST') {
        return initialState;
    }

    if (action.type === 'APM_BOM_SUCCESS' && action.payload) {
        return action.payload;
    }

    return state;
}

export default reducer;
